import { Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { AnimatedIconButton } from '@/components/common/AnimatedIconButton';
import { COMMON_STRING } from '@/constants/dictionary';

type SourceButtonsStackProps = {
  sourceId: string;
};

export const SourceButtonsStack = ({ sourceId }: SourceButtonsStackProps) => (
  <Box display='flex' justifyContent='flex-end'>
    <AnimatedIconButton
      size='small'
      data-action='update'
      data-source-id={sourceId}
      name={COMMON_STRING.UPDATE}
    >
      <EditIcon />
    </AnimatedIconButton>
    <AnimatedIconButton
      size='small'
      data-action='delete'
      data-source-id={sourceId}
      name={COMMON_STRING.DELETE}
    >
      <DeleteIcon />
    </AnimatedIconButton>
  </Box>
);
